import { useNavigate } from 'react-router-dom';
import { FeatureThemeProvider } from '../../../theme/FeatureThemeProvider';
import { TEMPLATE_BASE_PATH } from '../constants/templateApi';
import TemplateForm from '../components/form/TemplateForm';

export default function TemplateCreatePage() {
  const navigate = useNavigate();

  return (
    <FeatureThemeProvider>
      <TemplateForm onBack={() => navigate(`${TEMPLATE_BASE_PATH}/template-list`)} />
    </FeatureThemeProvider>
  );
}
